// Constants for the "send this to the dev team" flow in the Key AI chat.
//
// The backend (aiService `send_dev_request` tool -> devRequestService) writes one
// ActivityLogs row plus a JSON context file in S3; the admin-only /devrequests page
// reads them back. Both sides key off the constants here so the type string and the
// S3 prefix can never drift apart.
//
// CommonJS on purpose: doctivity-rest requires this file directly (see the other
// dual-consumed utils, e.g. EncounterTypeUtil), while the admin webpack build picks
// it up through utils/index.js.

const CATEGORIES = {
  ERROR: 'error',
  WRONG_RESULTS: 'wrong_results',
  STUCK: 'stuck',
  FEATURE_REQUEST: 'feature_request',
  OTHER: 'other',
};

const CATEGORY_LABELS = {
  [CATEGORIES.ERROR]: 'Error / crash',
  [CATEGORIES.WRONG_RESULTS]: 'Wrong or unexpected results',
  [CATEGORIES.STUCK]: 'Stuck / needs help',
  [CATEGORIES.FEATURE_REQUEST]: 'Feature request',
  [CATEGORIES.OTHER]: 'Other',
};

const DevRequestUtil = {
  // ActivityLogs.type — free-form STRING(64) in this codebase; there is no central
  // enum of activity types, so this constant is the closest thing to one.
  ACTIVITY_TYPE: 'AI_DEVREQUEST',

  // ActivityLogs.model — display grouping only, not a Sequelize model name.
  ACTIVITY_MODEL: 'Dev Request',

  // Key prefix inside UPLOADS_BUCKET_NAME. The download endpoint REQUIRES keys to
  // start with this, so it doubles as a security boundary — do not reuse it for
  // anything else, and do not relax the check in handler.js.
  S3_PREFIX: 'devrequests',

  CATEGORIES,
  CATEGORY_LABELS,

  isValidCategory(category) {
    return Object.values(CATEGORIES).includes(category);
  },

  categoryLabel(category) {
    return CATEGORY_LABELS[category] || CATEGORY_LABELS[CATEGORIES.OTHER];
  },
};

module.exports = { DevRequestUtil };
